import Refund from "./Refund";

export default [
    {
        path: "/refund-policy",
        name: "refund-policy",
        component: Refund,
    },
];
